export default __webpack_public_path__ + "static/media/icon-Hub-Workflow.a26320f8.svg";